import {memo} from 'react'

import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import NetSuggestions from '@adv-mt/mt-net-suggestions'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'
import {AiIcon} from '@adv-mt/ui/ai-icon'
import {ICON_SIZES} from '@adv-mt/ui/icon'
import {Body2, Headline1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-netAssistant`

const NetAssistant = ({adId, onOpenNet, pageName}) => {
  const {domain, i18n} = useSuiContext()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {NET_SUGGESTION_TYPE} = config.get('COMMON').AI_ASSISTANT
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_ACCESS_CLICKED} = {}} = config.get('tracking') || {}

  const onClickNetOption = params => {
    track({event: NET_ASSISTANT_ACCESS_CLICKED, data: {hit_origin: pageName}})
    onOpenNet(params)
  }

  const renderHeader = loading => (
    <div className={`${BASE_CLASS}-header`}>
      <div className={`${BASE_CLASS}-pretitle`}>
        <AiIcon loading={loading} size={ICON_SIZES.MD} />
        <Body2>{i18n.t('NET.ACCESS.SUGGESTIONS.PRETITLE')}</Body2>
      </div>
      <Headline1 className={`${BASE_CLASS}-title`}>{i18n.t('NET.ACCESS.SUGGESTIONS.TITLE_AD_DETAIL')}</Headline1>
    </div>
  )

  return (
    <section className={BASE_CLASS}>
      <NetSuggestions
        adId={adId}
        customHeader={renderHeader}
        onClickOption={onClickNetOption}
        isInlineOpenNetButton
        page={NET_SUGGESTION_TYPE.AD_DETAIL}
        className={`${BASE_CLASS}-suggestionsPanel`}
      />
    </section>
  )
}

NetAssistant.displayName = 'NetAssistant'

NetAssistant.propTypes = {
  adId: PropTypes.string,
  onOpenNet: PropTypes.func.isRequired,
  pageName: PropTypes.string
}

export default memo(NetAssistant)
